import React from 'react';
import { useNavigate } from "react-router-dom";

// 회사 소개 — SOFTCAT 디자인 시스템 이식본
const CORE_VALUES = [
    ["01", "혁신", "끊임없는 기술 혁신으로 최적의 솔루션을 제공합니다."],
    ["02", "신뢰", "고객과의 신뢰를 최우선으로 약속을 지킵니다."],
    ["03", "효율", "최고의 효율을 자랑하는 소프트웨어를 만듭니다."],
    ["04", "성장", "고객과 함께 성장하는 파트너가 되겠습니다."],
];

const TRACK_RECORD = [
    ["C.", "커머스 자동화", "쇼핑몰 재고 동기화, 거래명세 정리, 견적서 자동 작성 등 커머스 운영 도구 다수 납품."],
    ["M.", "마케팅 자동화", "N사·카페·블로그·SNS 채널의 수집·발행·응답 자동화 도구 개발."],
    ["D.", "데이터·리포트", "엑셀 보고서 생성, 키워드 광고 리포트 등 데이터 정리 자동화 구축."],
];

const TEAM = [
    ["SC-01", "박찬엽", "대표 · 총괄 개발"],
    ["SC-02", "송재용", "개발"],
];

const CompanyIntroPage = () => {
    const navigate = useNavigate();

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="sch-ph">
                <div className="sch-wrap">
                    <div className="sch-no">ABOUT — 소프트캣</div>
                    <h1>일하는 시간을<br />돌려드립니다</h1>
                    <p>
                        소프트캣은 소프트웨어 개발 및 공급을 전문으로 하며, 혁신적이고 효율적인
                        솔루션을 통해 고객의 비즈니스 성장과 성공을 돕습니다.
                    </p>
                </div>
            </div>

            <div className="sch-statstrip sch-wrap" style={{ padding: 0 }}>
                <div className="sch-st"><div className="sch-v">120<em>+</em></div><div className="sch-k">누적 개발 프로젝트</div></div>
                <div className="sch-st"><div className="sch-v">30<em>+</em></div><div className="sch-k">자체 자동화 도구</div></div>
                <div className="sch-st"><div className="sch-v">4.8<em>/5</em></div><div className="sch-k">평균 고객 별점</div></div>
                <div className="sch-st"><div className="sch-v">48<em>h</em></div><div className="sch-k">상담 회신 시간</div></div>
            </div>

            <section className="sch-sec">
                <div className="sch-wrap sch-sec__grid">
                    <div className="sch-sec__label">
                        <div className="sch-no">(01)</div>
                        <h2>핵심 가치</h2>
                    </div>
                    <div>
                        {CORE_VALUES.map(([i, title, desc]) => (
                            <div className="sch-svcrow" key={i}>
                                <div className="sch-i">{i}</div>
                                <h3>{title}</h3>
                                <p>{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="sch-sec">
                <div className="sch-wrap sch-sec__grid">
                    <div className="sch-sec__label">
                        <div className="sch-no">(02)</div>
                        <h2>개발 실적</h2>
                        <p>세 분야에서 120개 이상의 프로젝트를 수행했습니다.</p>
                    </div>
                    <div>
                        {TRACK_RECORD.map(([i, title, desc]) => (
                            <div className="sch-svcrow" key={i}>
                                <div className="sch-i">{i}</div>
                                <h3>{title}</h3>
                                <p>{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="sch-sec" style={{ borderBottom: "1px solid var(--ink)" }}>
                <div className="sch-wrap sch-sec__grid">
                    <div className="sch-sec__label">
                        <div className="sch-no">(03)</div>
                        <h2>팀</h2>
                    </div>
                    <div>
                        {TEAM.map(([code, name, role], idx) => (
                            <div
                                className="sch-trow"
                                key={code}
                                style={idx === TEAM.length - 1 ? { borderBottom: 0 } : undefined}
                            >
                                <div className="sch-code">{code}</div>
                                <b>{name}</b>
                                <span>{role}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="sch-ctax">
                <div className="sch-wrap">
                    <h2>어떤 업무를<br /><em>자동화</em>하고 싶으신가요?</h2>
                    <button
                        className="sch-bigbtn"
                        style={{ background: "#fff", color: "var(--primary-dark)" }}
                        onClick={() => { navigate("/custom-product-first"); window.scrollTo(0, 0); }}
                    >
                        무료 견적 받기
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                             strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                    </button>
                </div>
            </section>
        </>
    );
};

export default CompanyIntroPage;
